import React from 'react';
import PropTypes from 'prop-types';

import trackGTMEvents from 'shared-utils/src/trackGTMEvents/new';

import Spinner from '@components/common/Spinner';

const propTypes = {
  device: PropTypes.string,
  category: PropTypes.string,
  categoryValues: PropTypes.instanceOf(Array),
  availableResults: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  submitSearch: PropTypes.func,
  isFetching: PropTypes.bool,
  isAgencyHome: PropTypes.bool,
  agencyType: PropTypes.string,
  locations: PropTypes.instanceOf(Array),
  filters: PropTypes.instanceOf(Object),
  follow: PropTypes.bool,
};

const defaultProps = {
  device: '',
  category: '',
  categoryValues: [],
  availableResults: '',
  submitSearch: () => { },
  isFetching: false,
  isAgencyHome: false,
  agencyType: '',
  locations: [],
  filters: {},
  follow: false,
};

const createLabelAgency = ({ availableResults, agencyType, follow }) => {
  if (follow) {
    return {
      code: <><strong>Prosegui</strong></>,
      text: 'Prosegui',
    };
  }
  if (availableResults === '') {
    let text = agencyType === 'agencyPdp' ? 'Vedi agenzia' : 'Vedi risultati';
    return {
      code: text,
      text,
    };
  } 
  if (parseInt(availableResults, 10) === 0) {
    return {
      code: 'Nessuna agenzia disponibile',
      text: 'Nessuna agenzia disponibile',
    };
  }
  return {
    code: (
      <span>
        Vedi
        {' '}
        <strong>{availableResults}</strong>
        {' '}
        risultati
      </span>
    ),
    text: `Vedi ${availableResults} risultati`,
  };
};

const createLabel = (availableResults, value, values, { isAgencyHome, agencyType, follow }) => {

  if (isAgencyHome) {
    return createLabelAgency({
      availableResults,
      value,
      values,
      agencyType,
      follow,
    });
  }
  if (availableResults === '') {
    return {
      code: <span>Vedi risultati</span>,
      text: '',
    };
  }

  let categoryConf = values.filter(item => item.slug === value)[0];
  if (!categoryConf) {
    const filterOptionWithChildren = values.filter(item => 'children' in item)[0];
    [categoryConf] = filterOptionWithChildren.children.filter(item => item.slug === value);
    // categoryConf.ctaNoResultLabel
  }

  if (parseInt(availableResults, 10) === 0) {

    return {
      code: <span>Vedi Opzioni</span>,
      text: '',
    };
  }
      
  return {
    code: <>Vedi <strong>{availableResults}</strong> risultati</>,
    text: `Vedi ${availableResults} risultati`,
  };
};

const isButtonAvailable = ({
  locations,
  filters = {},
  follow,
}) => {
  if (!locations.length && !filters.nearby && !follow) {
    return false;
  }
  return true;
};

const SearchButton = ({
  device,
  category,
  categoryValues,
  availableResults,
  submitSearch,
  isFetching,
  isAgencyHome,
  agencyType,
  locations,
  filters,
  follow,
}) => {
  const isDisabled = !isButtonAvailable({
    locations,
    filters,
    follow,
  });

  const cssClassName = isDisabled ? 'searchButton' : 'searchButton available';

  const onClickAction = (e) => {
    let trackObj;
    if (follow) {
      trackObj = {
        category: 'AgencyRecommender',
        action: 'GoToAgencyRecommender',
        position: 'AgenciesHP',
      };
    } else {
      trackObj = {
        category: 'Interaction',
        action: 'SeeResultsFromHP',
      };
    }
    trackGTMEvents(trackObj);
    submitSearch(e);
  };

  const zeroResults = !isFetching && !!availableResults && parseInt(availableResults, 10) === 0;
  
  const { code, text } = createLabel(availableResults, category, categoryValues, { isAgencyHome, agencyType, follow });

  return (
    <div id="searchButton" className={cssClassName}>
      {
        zeroResults
          && <p className={`pb--xs tp-s--x${device === 'smartphone' ? '2' : ''}s tp-w--m c-txt--w`}>Nessun risultato al momento</p>
      }
      <button
        type="button"
        aria-label={text || 'Avvia la ricerca'}
        aria-description={text ? 'Avvia la ricerca' : null}
        aria-live="polite"
        onClick={onClickAction}
        disabled={isDisabled}
      >
        {
          isFetching && !follow
            ? <Spinner valignCenter="true" size="l" color="w" />
            : code
        }
      </button>
    </div>
  );
};
SearchButton.propTypes = propTypes;
SearchButton.defaultProps = defaultProps;
export default SearchButton;
